export const proposals = () => {
  return {
    labels: {
      proposal: 'Propuesta',
      submit_date: 'Fecha de envío',
      service_provided: 'Servicio proporcionado para',
      add_attachment: 'Agregar adjunto',
      client: 'Cliente',
      location: 'Ubicación',
      approver: 'Aprobador designado',
      contact: 'Persona de contacto',
      priority: 'Prioridad',
      trade: 'Oficio',
      product_or_service: 'Producto o Servicio',
      leave_page: 'Salir de la página',
      continue: 'Continuar editando',
      sort: 'Ordenar',
      highest: 'Mayor',
      lowest: 'Menor',
      newest: 'Más reciente',
      oldest: 'Más antiguo',
      clear: 'Limpiar',
      select_one: 'Seleccione uno',
      proposals_linked: 'Propuestas vinculadas',
      related_wo_title: 'Información de la Orden de Trabajo relacionada',
      wo_number: 'Orden de Trabajo #',
      wo_notes: 'Notas de la Orden de Trabajo',
      direct_link: 'Enlace directo'
    },
    placeholder: {
      description: 'Escriba la descripción de su propuesta',
      item_desc: 'Ingrese la descripción',
      select_one: 'Seleccione uno',
      select_priority: 'Seleccione la prioridad',
      select_trade: 'Seleccione el oficio'
    },
    column_names: {
      client_name: 'Nombre del Cliente',
      client_location: 'Ubicación',
      proposal_id: 'Propuesta #',
      workorder_number: 'Orden de Trabajo #',
      submitted_date: 'Fecha de Envío',
      approved_date: 'Fecha de Aprobación',
      approved_by: 'Aprobador Designado',
      status: 'Estado',
      priority: 'Prioridad',
      trade: 'Oficio',
      description: 'Descripción',
      item: 'Ítem',
      item_description: 'Descripción de la Propuesta',
      tax: 'Impuesto % (Monto)',
      rate: 'Tarifa',
      quantity: 'Cantidad',
      amount: 'Monto'
    },
    status: {
      approved: 'Aprobado',
      closed: 'Cerrado',
      draft: 'Borrador',
      declined: 'Rechazado',
      in_review: 'En Revisión',
      pending_decision: 'Decisión Pendiente'
    },
    actions: {
      submit: 'Enviar',
      save: 'Guardar Borrador',
      add_item: 'Agregar Ítem',
      add_proposal: 'Agregar Nueva Propuesta',
      link_proposal: 'Vincular Propuesta Existente',
      paste_description: 'Copiar Descripción de Orden de Trabajo'
    },
    audit: 'Auditoría',
    audit_actions: {
      create: 'Propuesta generada',
      edit: 'Propuesta guardada como borrador',
      submit: 'Propuesta enviada',
      reject: 'Propuesta rechazada',
      approve: 'Propuesta aprobada',
      review: 'Propuesta en revisión'
    },
    tooltips: {
      proposal_id:
        'El ID es editable para que pueda usar su propio ID de propuesta. El ID puede ser números o letras y debe ser único. Las primeras 3 letras son su código de empresa único y no se pueden cambiar.',
      status:
        'Complete su propuesta y envíela para su aprobación. También puede guardarla como Borrador y enviarla más tarde.',
      approver:
        'Persona responsable por aprobar la Propuesta o quien solicita la Propuesta.',
      copy: 'Copia la Descripción de la Order de Trabajo en el campo Descripción de la Propuesta, esto le proveerá un punto de inicio para su propuesta.'
    },
    summary: {
      subtotal: 'Subtotal',
      tax: 'Impuesto',
      total: 'Monto Total'
    },
    error: {
      id_in_use: 'Este ID ya ha sido utilizado',
      update_error: 'El registro no se actualizó'
    },
    messages: {
      success_title: 'Propuesta Guardada',
      proposal_number: 'Propuesta %NUMBER%',
      success_message: ' se guardó exitosamente.',
      leave_title: 'Tiene cambios sin guardar en esta Propuesta.',
      leave_title2: 'Si sale de esta página, estos cambios se perderán.',
      leave_secondary: '¿Está seguro de que desea salir de esta página?',
      empty_message_title: 'No tiene ninguna Propuesta',
      empty_message:
        'Puede crear una Propuesta desde una Orden de Trabajo o una Propuesta no vinculada haciendo clic en "Crear Propuesta" en esta página.',
      empty_message_filters:
        'Su búsqueda no arrojó resultados. Verifique sus criterios de búsqueda e inténtelo de nuevo.'
    }
  }
}
